import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9c1b2d94&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&lang=css&"
import style2 from "./App.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./i18n/main.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fsrv%2Fphx%2Fatm%2Fv%2Fsrc%2FApp.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports